/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscriptionresultbtnok3Inputs */



/**
* | output |
* | --- |
* | "Okay" |
*
* @param {Subscriptionresultbtnok3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscriptionresultbtnok3 = /** @type {((inputs?: Subscriptionresultbtnok3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscriptionresultbtnok3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Okay")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vale")
	return /** @type {LocalizedString} */ ("Окей")
});
export { subscriptionresultbtnok3 as "subscriptionResultBtnOk" }